import { Model } from "./../../classes/mvc/Model";

export class ModelLightbox extends Model {

}